export type CzechPluralForms = {
    one: string;
    few: string;
    many: string;
};

export const czechPluralize = (count: number, forms: CzechPluralForms): string => {
    const abs = Math.abs(count);
    if (abs === 1) return forms.one;
    if (abs >= 2 && abs <= 4) return forms.few;
    return forms.many;
};

export type Unit = 'week' | 'day' | 'hour' | 'minute' | 'workday' | 'snack';

export const unitLabel = (count: number, unit: Unit): string => {
    switch (unit) {
        case 'week':
            return czechPluralize(count, { one: 'týden', few: 'týdny', many: 'týdnů' });
        case 'day':
            return czechPluralize(count, { one: 'den', few: 'dny', many: 'dní' });
        case 'hour':
            return czechPluralize(count, { one: 'hodina', few: 'hodiny', many: 'hodin' });
        case 'minute':
            return czechPluralize(count, { one: 'minuta', few: 'minuty', many: 'minut' });
        case 'workday':
            return czechPluralize(count, { one: 'pracovní den', few: 'pracovní dny', many: 'pracovních dní' });
        case 'snack':
            return czechPluralize(count, { one: 'svačina', few: 'svačiny', many: 'svačin' });
    }
};
